import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiUpdateUserBadgeRequestBody,
  IApiUpdateUserBadgeResponseBody,
} from '../UserBadgesApi.types';
import { useApi } from '~/lib/api/useApi';
import { userBadgeQueryKeyFactory } from './useUserBadgeQuery';
import { userBadgesQueryKeyFactory } from './useUserBadgesQuery';

export type IUseUpdateUserBadgeMutationValues = {
  appId: string;
  userBadgeId: string;
  body: IApiUpdateUserBadgeRequestBody;
};

export const useUpdateUserBadgeMutation = (): UseMutationResult<
  IApiUpdateUserBadgeResponseBody,
  unknown,
  IUseUpdateUserBadgeMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) =>
      api.userBadges.update(values.appId, values.userBadgeId, values.body),
    onSuccess: async (updatedUserBadge) => {
      queryClient.setQueryData(
        userBadgeQueryKeyFactory({
          appId: updatedUserBadge.userBadge.appId,
          userBadgeId: updatedUserBadge.userBadge._id,
        })!,
        updatedUserBadge.userBadge,
      );
      await queryClient.invalidateQueries({
        queryKey: userBadgesQueryKeyFactory({
          appId: updatedUserBadge.userBadge.appId,
        }),
      });
    },
  });
};
